import { c as _c } from "react/compiler-runtime";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";
import { m } from "framer-motion";
import { ProcessFlowProps } from "./types";
export const ProcessFlow: React.FC<ProcessFlowProps> = t0 => {
  const $ = _c(10);
  const {
    phases
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      threshold: 0.1,
      triggerOnce: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    ref: flowRef,
    isInView: flowInView
  } = useScrollAnimation(t1);
  let t2;
  if ($[1] !== flowInView || $[2] !== phases) {
    let t3;
    if ($[4] !== flowInView || $[5] !== phases.length) {
      t3 = (phase, phaseIndex) => <m.div key={phaseIndex} initial={{
        opacity: 0,
        y: 30
      }} animate={flowInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.5,
        ease: "easeOut",
        delay: phaseIndex * 0.2
      }}><div className="bg-white border border-[#F0CACA] rounded-xl p-4 shadow-sm"><div className="mb-4"><h3 className="text-lg font-bold text-[#151111]">{phase.title}</h3>{phase.subtitle && <span className="text-sm text-[#5B1B1A]/70"> {phase.subtitle}</span>}</div><div className="space-y-4">{phase.steps.length === 3 ? <div className="flex justify-between items-start">{phase.steps.map(_temp)}</div> : phase.steps.length === 4 ? <div className="flex justify-between items-start">{phase.steps.map(_temp2)}</div> : <div className="flex justify-center"><div className="flex flex-col items-center"><div className="w-15 h-15 rounded-full bg-[#FAEDED] flex items-center justify-center mb-2"><div className="text-[#7F2525]">{phase.steps[0].icon}</div></div><span className="text-xs text-[#151111] text-center">{phase.steps[0].title}</span></div></div>}{phase.steps.length > 3 && phase.title.includes("Sales") && <div className="flex justify-between items-start">{phase.steps.slice(1).map(_temp3)}</div>}</div></div>{phaseIndex < phases.length - 1 && <div className="flex justify-center py-2"><svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 1C11.5 0.447715 11.9477 0 12.5 0C13.0523 0 13.5 0.447715 13.5 1V28.5859L18.1569 23.9287C18.5474 23.5385 19.1806 23.5383 19.571 23.9287C19.9615 24.3191 19.9615 24.9522 19.571 25.3428L13.2071 31.707C12.8166 32.0976 12.1834 32.0976 11.7929 31.707L5.42893 25.3428C5.03841 24.9522 5.03841 24.3191 5.42893 23.9287C5.81946 23.5383 6.45262 23.5385 6.84315 23.9287L11.5 28.5859V1Z" fill="#5B1B1A" /></svg></div>}</m.div>;
      $[4] = flowInView;
      $[5] = phases.length;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = phases.map(t3);
    $[1] = flowInView;
    $[2] = phases;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[7] !== flowRef || $[8] !== t2) {
    t3 = <div ref={flowRef} className="w-full max-w-md mx-auto space-y-6">{t2}</div>;
    $[7] = flowRef;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
function _temp(step, stepIndex) {
  return <div key={stepIndex} className="flex flex-col items-center flex-1"><div className="w-15 h-15 rounded-full bg-[#FAEDED] flex items-center justify-center mb-2"><div className="text-[#7F2525]">{step.icon}</div></div><span className="text-xs text-[#151111] text-center max-w-[70px] leading-tight min-h-[32px] flex items-center">{step.title}</span></div>;
}
function _temp2(step_0, stepIndex_0) {
  return <div key={stepIndex_0} className="flex flex-col items-center flex-1"><div className="w-15 h-15 rounded-full bg-[#FAEDED] flex items-center justify-center mb-2"><div className="text-[#7F2525]">{step_0.icon}</div></div><span className="text-xs text-[#151111] text-center max-w-[60px] leading-tight min-h-[32px] flex items-center">{step_0.title}</span></div>;
}
function _temp3(step_1, stepIndex_1) {
  return <div key={stepIndex_1 + 1} className="flex flex-col items-center flex-1"><div className="w-15 h-15 rounded-full bg-[#FAEDED] flex items-center justify-center mb-2"><div className="text-[#7F2525]">{step_1.icon}</div></div><span className="text-xs text-[#151111] text-center max-w-[70px] leading-tight min-h-[32px] flex items-center">{step_1.title}</span></div>;
}